import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// DESTORY_CAREPLAN_ENTITY

const mutation = gql`
  mutation destroyRoadmapEntity(
    $roadmap_id: ID!
    $entity_id: ID!
    $entity_type: ROADMAP_ENTITY_SOURCE_TYPE!
  ) {
    destroyRoadmapEntity(
      roadmap_id: $roadmap_id
      entity_id: $entity_id
      entity_type: $entity_type
    ) {
      id
    }
  }
`

export default function useDeleteRoadmapEntity(
  successMessage = 'Provider/Facility deleted'
) {
  const { onMutate: onDeleteRoadmapEntity, loading } = useSafeRunMutation({
    mutation,
    successMessage,
    responsePath: 'destroyRoadmapEntity',
    update: (cache, _result, { variables }) => {
      if (!variables) return
      const { roadmap_id, entity_id, entity_type } = variables
      const field =
        entity_type === 'Facility'
          ? 'suggested_facilities'
          : 'suggested_doctors'

      cache.modify({
        id: cache.identify({ __typename: 'RoadmapV2', id: roadmap_id }),
        fields: {
          [field]: (existing, { readField }) =>
            (existing || []).filter(entity => {
              const profile = readField('profile', entity)
              return profile && readField('id', profile) !== entity_id
            })
        }
      })
    }
  })
  return { onDeleteRoadmapEntity, loading }
}
